import React, { PropTypes } from 'react';

import Toastr from './ReduxToastr';

import Router from '../../routes';
import DevTools from './DevTools';
import Provider from './Provider';

const Root = ({ store, history }) => (
  <Provider store={store}>
    <div>
      <Toastr />
      <Router history={history} />
      <DevTools />
    </div>
  </Provider>
)

Root.propTypes = {
  store: PropTypes.shape.isRequired,
  history: PropTypes.shape.isRequired
}

export default Root



// WEBPACK FOOTER //
// ./containers/Root/Root.dev.js